// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfViewer_container__2O5FT","loaderWrap":"PdfViewer_loaderWrap__3U08B","pdfViewerModal":"PdfViewer_pdfViewerModal__EhEDX","page":"PdfViewer_page__eM92M"};